import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';
import Link from '../../../Core/Link';
import Image from '../../../Core/Image';
import MultiColumnLayout from '../../Shared/MultiColumnLayout';

// * The Left aligned columns class applies the styling shown on the homepage (all text & img left aligned, makes image larger)

// * Applies the bg color
export const Wrapper = styled.div`
  background-color: ${({ colourOverrideBackground }) =>
    colourOverrideBackground || themeGet('colors.accent')};
  background-image: url(${({ background }) => background});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  &.left-aligned-columns {
    background-color: ${({ colourOverrideBackground }) =>
      colourOverrideBackground || themeGet('colors.neutral_2')};
  }
`;

// * Acts as the grid
export const StyledContainer = styled(Container)`
  padding: 50px 0 60px;
  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    color: ${themeGet('colors.text-secondary')};
    text-align: center;
    margin-bottom: 52px;

    ${Wrapper}.left-aligned-columns & {
      margin-bottom: 40px;
    }

    ${Wrapper}.text-dark & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.text-light & {
      color: ${themeGet('colors.text-primary')};
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: 50px 45px 60px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 45px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 70px 90px 90px;
  }
`;

// * The image that appears in each column
export const StyledImage = styled(Image)`
  margin: 0 auto 39px;

  max-height: 144px;
  max-width: 144px;
  width: 100%;
  height: 100%;

  ${Wrapper}.left-aligned-columns & {
    margin: 0 0 39px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-height: 144px;
    max-width: 144px;
    margin-right: 24px;

    ${Wrapper}.left-aligned-columns & {
      margin-right: 36px;

      max-height: 180px;
      max-width: 180px;
      width: 100%;
      height: 100%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 0 auto 39px;

    ${Wrapper}.left-aligned-columns & {
      margin: 0 0 39px;
    }
  }
`;

export const Columns = styled(MultiColumnLayout)`
  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    // * Targets every 1st and 3rd
    ${Wrapper}.left-aligned-columns & {
      justify-content: space-between;
      > div {
        &:nth-child(3n + 1),
        &:nth-child(3n) {
          max-width: 330px;
        }
      }
    }
  }
`;

// * The parent el of Each child item
export const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  p {
    margin-bottom: 25px;

    &:last-child {
      margin-bottom: 0;
      /* margin-top: auto; */
    }
  }

  // * The style that is applied on the homepage
  ${Wrapper}.left-aligned-columns & {
    p {
      text-align: left;
      margin-bottom: 25px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  /* for IE */
  width: 100%;

  h1,
  p {
    /* for IE */
    width: 100%;
  }

  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6 {
    color: ${themeGet('colors.text-secondary')};

    font-size: 26px;
    line-height: 38px;
    text-align: center;
    font-weight: 600;
    margin-bottom: 10px;

    // * The style that is applied on the homepage
    ${Wrapper}.left-aligned-columns & {
      text-align: left;
      margin-bottom: 20px;
    }
  }

  > h4,
  > h5,
  > h6 {
    font-size: 20px;
  }

  ${Wrapper}.left-aligned-columns & {
    align-items: flex-start;
  }

  > h1,
  > h2,
  > h3,
  > h4,
  > h5,
  > h6,
  > p {
    ${Wrapper}.text-dark & {
      color: ${themeGet('colors.text-secondary')};
    }
    ${Wrapper}.text-light & {
      color: ${themeGet('colors.text-primary')};
    }
  }

  > p a {
    font-size: 16px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    > h1,
    > h2,
    > h3,
    > h4,
    > h5,
    > h6 {
      text-align: left;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    > h1,
    > h2,
    > h3,
    > h4,
    > h5,
    > h6 {
      text-align: center;
    }
    > p a {
      font-size: 18px;
    }
  }
`;

export const StyledLink = styled(Link)`
  margin-top: auto;
`;

export const SectionFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-top: 30px;

  h3,
  h4 {
    margin-bottom: 30px;
  }
`;
